import { connect } from "react-redux";
import { getVariation } from "firefly/utils";
import Home, { HOMEPAGE_EXPERIMENT_ID } from "marketing/components/home";

const mapStateToProps = (state) => ({
  variation: getVariation(HOMEPAGE_EXPERIMENT_ID, state) ?? 0,
});

export default connect(mapStateToProps)(Home);
